import { useEffect, useRef } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

// Reports anonymous "no result" searches / filter combos once per unique combination per visit.
export const useFaqMissLogger = ({ ready, resultCount, filters }) => {
  const seen = useRef(new Set());

  useEffect(() => {
    if (!ready || resultCount > 0) return undefined;
    const query = filters.query.trim().toLowerCase();
    const hasFilters = Boolean(filters.type || filters.topic || filters.audience);
    let payload = null;
    if (query.length >= 3) payload = { kind: 'search', query };
    else if (!query && hasFilters) payload = { kind: 'filter', type: filters.type, topic: filters.topic, audience: filters.audience };
    if (!payload) return undefined;
    const key = JSON.stringify(payload);
    if (seen.current.has(key)) return undefined;

    const timer = setTimeout(() => {
      seen.current.add(key);
      fetch(`${API}/api/faq/search-miss`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    }, 1500);
    return () => clearTimeout(timer);
  }, [ready, resultCount, filters]);
};
